export const logisticsRoot = '/logistics'

export const logisticsRoute = {
  events: '/events',
  planning: '/planning',
}
